import { useRouter } from 'next/navigation';
import { UrlObject } from 'url';

export type Url = UrlObject | string;

export function useNavigate() {
	const router = useRouter();

	return (url: Url, options?: { scroll: boolean }) => {
		if (typeof url === 'string') {
			router.push(url, options);
		} else {
			throw new Error('Invalid URL type');
		}
	};
}
